export default function BonsConfiguration($translatePartialLoaderProvider) {
    $translatePartialLoaderProvider.addPart('bons');
}

BonsConfiguration.$inject = ['$translatePartialLoaderProvider'];
